import type { MembershipDto, SessionDto } from "@bafe/api-client";
import type { OrganisationRole } from "@bafe/types";

import { appRoutePath } from "./platform-navigation.js";
import { parseWorkspaceLocation } from "./workspace-url.js";

/** Default landing route after sign-in when no deep link is requested. */
export const USER_DASHBOARD_HOME = "/user/workspaces";

const USERS_ROLES = new Set<OrganisationRole>(["owner", "admin"]);
const BILLING_ROLES = new Set<OrganisationRole>(["owner", "admin", "billing"]);

export function membershipsForUserUsers(memberships: MembershipDto[]): MembershipDto[] {
	return memberships.filter((membership) => USERS_ROLES.has(membership.role));
}

export function membershipsForUserBilling(memberships: MembershipDto[]): MembershipDto[] {
	return memberships.filter((membership) => BILLING_ROLES.has(membership.role));
}

/** True on `/user/*` routes outside a workspace slug (personal dashboard). */
export function isUserDashboardRoute(pathname: string): boolean {
	const path = appRoutePath(pathname.split("?")[0] ?? pathname);
	if (parseWorkspaceLocation(path)) return false;
	return (
		path === "/user/workspaces" ||
		path === "/user/billing" ||
		path === "/user/users" ||
		path === "/user/settings" ||
		path.startsWith("/user/settings/")
	);
}

export function postSignInPath(session: SessionDto, next: string): string {
	if (next !== "/" && next !== USER_DASHBOARD_HOME) return next;
	const membership = session.memberships[0];
	if (membership && membership.role === "support_viewer") {
		return USER_DASHBOARD_HOME;
	}
	return USER_DASHBOARD_HOME;
}
